// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../node_modules/.0.28.9@css-loader/index.js?minimize!../../../../../node_modules/.13.7.1@vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-71a57ac8\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/.13.7.1@vue-loader/lib/selector.js?type=styles&index=0!./ImagePreviewBox.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../../../node_modules/.3.1.2@vue-style-loader/lib/addStylesClient.js")("d0f57544", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./node_modules/.3.1.2@vue-style-loader!./node_modules/.0.28.9@css-loader?minimize!./node_modules/.13.7.1@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-71a57ac8","scoped":true,"hasInlineConfig":false}!./node_modules/.13.7.1@vue-loader/lib/selector.js?type=styles&index=0!./src/packages/components/messageBox/components/ImagePreviewBox.vue
// module id = 71
// module chunks = 0 1